<template>
  <div>
  <table class="table bloco-table" >
    <thead>
      <tr >
        <th scope="col" style="border-radius: 8px 0 0 0;">ID Tarefa</th>
        <th scope="col">Código Cir</th>
        <th scope="col">Serviço</th>
        <th scope="col">Tarefa</th>
        <th scope="col">Status</th>
        <th scope="col">Data Início Tarefa</th>
        <th scope="col" style="border-radius:0 8px 0 0;"> </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(item, index) in dadosFichaTecnica.tarefas_bloco"
          :key="index">
        <td> {{ item.pco_tarefa_id }}</td>
        <td> {{ item.cod_cir }}/{{ item.ponta.toUpperCase() }}</td>

        <td> {{ (item.servico || '').toUpperCase() }}</td>
        <td> {{ item.tarefa }}</td>
        <td> {{ item.status_tarefa }} </td>
        <td> {{ formataDataBr(item.created_at) }} </td>
        <td class="text-center">  
            <SGPFormBotaoComponent
              v-if="!item.finalized_at"
              text
              @click="excluirItem(item.pco_tarefa_id)"
              color="primary"
              x-small
            >
              <SGPIconComponent
                icon="mdi-trash-can-outline"
                color="black"
              />
            </SGPFormBotaoComponent>
            <a :href="getLinkFichaTecnica(item.pco_tarefa_id)">
            <SGPFormBotaoComponent
              text
              color="orange"
              x-small
            >
              <SGPIconComponent
                icon="mdi-eye"
                color="primary"
              />
            </SGPFormBotaoComponent>
          </a>
        </td>
      </tr>
    </tbody>
  </table>

  <div>
    <SGPConfirmacaoDelecaoComponent
        v-if="abrirModalDesagruparDados"
        @sgpCancelarDelecaoEmit="cancelarDesagrupar()"
        @sgpConfirmarDelecaoEmit="confirmarDesagrupar()"
        titulo="Atenção:"
        subtitulo="Tem certeza que deseja retirar o circuito do tratamento em bloco?"
    />
  </div>

  </div>
</template>

<script>
import { formataDataBr } from '@/common/boot/Utils'
import { mapActions, mapGetters } from 'vuex';

export default {
  name: "BlocoTableComponent",
  props: {
    dadosFichaTecnica: {
      type: Object,
      required: true
    }
  },

  data (){
    return {
        abrirModalDesagruparDados:false,
        itensDesagrupar: [],
        abrirModalDesfazerBlocoInteiro:false,
    } 
  },

  computed: {
    ...mapGetters('fichaTecnicaWorkflow', ['loadingFichaTecnica','dadosFichaTecnica']),
  },

  methods: {
    ...mapActions('fichaTecnicaWorkflow', ['desagruparTarefasBloco', 'desfazerBloco','buscarDadosFichaTecnica']),

    getLinkFichaTecnica(item) {
      var link = '';

      link = process.env.VUE_APP_FICHA_TECNICA_URL // '/sgp/nova-ficha-tecnica/'
      link += item
      
      return link == '' ? '#' : link;
    },

    excluirItem (item) {
      this.abrirModalDesagruparDados = true
      this.itensDesagrupar = [ item ]
    },

    cancelarDesagrupar() {
      this.abrirModalDesagruparDados = false
    },

    confirmarDesagrupar() {
      this.desagruparTarefasBloco({
        array_pco_tarefas_ids:this.itensDesagrupar, 
        agrupavel:0,
        pco_tarefa_id:this.dadosFichaTecnica.pco_tarefa_id
      })
    },

    desfazerBlocoInteiro () {
      this.abrirModalDesfazerBlocoInteiro = true;
    },

    async  confirmarDesfazerBloco() {
      this.abrirModalDesagruparDados = false
      await this.desfazerBloco({id:this.dadosFichaTecnica.tarefas_bloco[0].ctrl_bloco_id});
      this.buscarDadosFichaTecnica(this.$route.params.pco_tarefa_id); 
    },

    cancelarDesfazerBloco() {
      this.abrirModalDesfazerBlocoInteiro = false
    },
    
    formataDataBr
  }
}
</script>

<style lang="scss">
  .bloco-table {
    margin: 0;
    border: 0;
    tr {
      
      td { background: #fff; }
      
      &:nth-child(odd) {
        td { 
          background-color: #f8f8f8; 
          border-bottom: solid 1px #ddd !important;
        }
      }
      
      &:last-child {
        border-style: none !important;
        border-color: transparent;
        td { 
          &:first-child { border-radius: 0 0 0 8px; }
          &:last-child { border-radius: 0 0 8px 0px; }
        }
      }
    }
  }
</style>